<script setup lang="ts">
defineProps({
  name: {
    type: String,
    default: 'option',
  },
  index: {
    type: Number,
    default: 0,
  },
  label: {
    type: String,
    default: 'Label',
  },
});
</script>

<template>
  <label :for="`${name}-${index}`" :class="$style.label">{{ label }}</label>
</template>

<style module>
.label {
  margin-left: 0.875rem;
  cursor: pointer;
  display: inline-block;
}
</style>
